module.exports = __webpack_public_path__ + "static/media/MainHeader.89bd1797.jpg";